import { render, staticRenderFns } from "./NlLoader.vue?vue&type=template&id=484cacd8&scoped=true&"
import script from "./NlLoader.vue?vue&type=script&lang=js&"
export * from "./NlLoader.vue?vue&type=script&lang=js&"
import style0 from "./NlLoader.vue?vue&type=style&index=0&id=484cacd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cacd8",
  null
  
)

export default component.exports